export function statusClass(status: string): string {
  const classes: Record<string, string> = {
    pending: "badge bg-warning text-dark",
    resolved: "badge bg-success",
    dismissed: "badge bg-secondary",
  };
  return classes[status] || "badge bg-secondary";
}
